export const PIN_HEADER = 'Profile PIN'

export const PIN_SUBHEADER_NO_PIN = 'Set up optional PIN protection in order to restrict switching between profiles or accessing profile settings. PIN protection can also be used for validating movie rental purchases.'
export const PIN_SUBHEADER_HAS_PIN = 'PIN protection has been setup. Click below to edit your PIN.'
export const PIN_SUBHEADER_EDITABLE = 'Update your PIN number below.'

export const PIN_CTA_NO_PIN = 'Set up PIN'
export const PIN_CTA_HAS_PIN = 'Change your PIN'

export const PIN_HELP_TEXT = 'Please create your 4-digit account PIN'

export const PIN_SETTINGS_HEADER = 'Use PIN for:'
export const PIN_SETTINGS_TOOLTIP = 'Please setup a PIN to enable this option.'
export const PIN_SETTINGS_SWITCH_PROFILE_TEXT = 'Switching profiles'
export const PIN_SETTINGS_SWITCH_PROFILE_SUBTEXT = 'PIN required to switch from profile with a lower content rating restriction to a higher content rating restriction (e.g. from G to M)'
export const PIN_SETTINGS_MANAGE_PROFILE_TEXT = 'Accessing profile settings'
export const PIN_SETTINGS_MANAGE_PROFILE_SUBTEXT = 'PIN required to create new profiles or to edit existing profiles'

export const PURCHASING_HEADER = 'Password / PIN purchase settings'
export const PURCHASING_SUBHEADER = 'To keep your account secure we require you to enter your account password when making a purchase and using a saved credit card. Alternatively, you can use your PIN to validate your movie rentals. Select one from the security options below.'
export const PURCHASING_PASSWORD_TEXT = 'Password protection'
export const PURCHASING_PASSWORD_SUBTEXT = 'Requires password to rent movies using a saved credit card.'
export const PURCHASING_PASSWORD_TOOLTIP = 'Please setup a PIN to disable this option.'
export const PURCHASING_PIN_TEXT = 'PIN protection'
export const PURCHASING_PIN_SUBTEXT = 'Requires PIN to rent movies using a saved credit card.'
export const PURCHASING_PIN_TOOLTIP = 'Please setup a PIN to enable this option.'
